<template>
  <div>
    <div
      :class="[
        {
          'show-more': isLoadMore,
          'index': !isLoadMore,
          'video-creator__container': videoCreator,
        },
        'featured-article-videos',
      ]"
    >
      <div
        v-if="!isLoadMore && !videoCreator"
        class="featured-article-videos__heading"
      >
        <h1>VIDEOS</h1>
      </div>
      <div v-if="articleVideos.length > 0">
        <transition-group
          name="list"
          class="featured-article-videos__list container"
        >
          <ArticleVideoBlockComponent
            v-for="video in articleVideos"
            :key="video.node.id"
            :video="video.node"
          />
        </transition-group>
        <div class="featured-article-videos__footer">
          <div v-if="hasNextPage">
            <div v-if="isLoading">
              <i class="fas fa-circle-notch fa-spin" />
            </div>
            <a
              v-else
              class="featured-videos__link"
              @click="loadMoreArticleVideos"
            >
              <span> Load more </span>
            </a>
          </div>
        </div>
      </div>
      <div
        v-else
        class="featured-article-videos__empty"
      >
        <p>NO VIDEOS</p>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import ArticleVideoBlockComponent from './ArticleVideoBlockComponent.vue';

export default {
  name: 'ArticleVideoList',
  
  components: {
    ArticleVideoBlockComponent,
  },
  props: {
    videoCreator: {
      type: String,
      default: null,
    },
    isLoadMore: {
      type: Boolean,
      default: false,
    },
    except: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      skipQuery: true,
      hasNextPage: true,
      articleVideos: [],
      cursor: null,
    };
  },
  
  created () {
    this.mobileVideosCount = 7;
    this.desktopVideosCount = 10;
    this.numberVideos = this.$isMobile ? this.mobileVideosCount : this.desktopVideosCount
  },

  apollo: {
    information: {
      query: gql`
        query visitorInformation {
          visitorInformation {
            country
            locale
          }
        }
      `,
      update(data) {
        return data.visitorInformation;
      },
    },
    articleVideos: {
      query: gql`
        query getArticleVideos(
          $locale: String!
          $country: String!
          $cursor: String
          $videoCreator: ID
          $except: String
          $number: Int!
        ) {
          articleVideos(
            first: $number
            after: $cursor
            locale: $locale
            country: $country
            videoCreatorId: $videoCreator
            except: $except
          ) {
            edges {
              node {
                id
                title
                subtitle
                featuredImage
                duration
                publishedAt
                formattedViews
                url
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
        }
      `,
      loadingKey: 'isLoading',
      variables() {
        return {
          number: this.numberVideos,
          locale: this.information.locale,
          country: this.information.country,
          cursor: this.cursor,
          videoCreator: this.videoCreator,
          except: this.except,
        };
      },
      update(data) {
        this.hasNextPage = data.articleVideos.pageInfo.hasNextPage;
        return [...this.articleVideos, ...data.articleVideos.edges];
      },
      result({ loading, data }) {
        this.skipQuery = true;
        this.isLoading = false;
        if (!loading) {
          this.cursor = data.articleVideos.pageInfo.endCursor;
        }
      },
      skip() {
        return this.skipQuery;
      },
    },
  },
  methods: {
    loadMoreArticleVideos() {
      this.skipQuery = false;
      this.isLoading = true;
      // uses refetch instead of fetchMore as we are skipping the initialQuery.
      this.$apollo.queries.articleVideos.refetch();
    },
  },
  watch: {
    information(val, oldVal) {
      if (oldVal == null && val != null) {
        this.loadMoreArticleVideos();
      }
    },
  },
};
</script>
